export default {
    title: "O-I",
    support: "Unterstützung",
    dashboard: "Armaturenbrett"
}